// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"7e4ccfd1","318":"0e134724","453":"35c191a5","604":"78bf77ea","938":"b5805e70","949":"c84130ff","981":"834198dd"}[chunkId] + ".chunk.js";
};